import React, { Component } from 'react';
import Select from 'react-select';
import Button from 'components/button/v2/Button';
import {
  claimSchool,
  getAutocompleteSchools,
  resetAutocompleteSchools,
  sendClaimVerificationCode,
} from 'redux/school/school-actions';
import NewDropdown from 'components/form/dropdown/NewDropdown';
import { connect } from 'react-redux';
import Text from 'components/form/text/Text';
import Autocomplete from 'react-autocomplete';
import GooglePlacesField from 'components/google-places-field/google-places-field';
import ReCAPTCHA from 'react-google-recaptcha';
import config from 'config';
import states from 'util/states-array';
import Dropdown from 'components/form/dropdown/Dropdown';
import Validation from 'components/form/Validation';
import { withRouter } from 'react-router';
import client from 'redux/client';
import Modal from 'components/modal/Modal';
import ReactPixel from 'react-facebook-pixel';
import { tString } from '../../../translation/Translation';
import { withTranslation } from 'react-i18next';
import ClaimFormCheckboxes from './claim-form-checkboxes';
import styles from './claim-form-landing.module.scss';
import { _verifyRecaptcha } from 'controllers/recaptcha/recaptcha_controllers';

const stateOptions = [{ value: '', disabled: true }].concat(states);
const defaultGrades = ['Pre-K', 'TK', 'HS', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
const videoUrl = 'https://www.youtube.com/embed/oRnnpIiia4o?autoplay=1&rel=0';

class ClaimForm extends Component {
  constructor(props) {
    super(props);
    this.digit1 = React.createRef();
    this.digit2 = React.createRef();
    this.digit3 = React.createRef();
    this.digit4 = React.createRef();
    this.digit5 = React.createRef();
    this.digit6 = React.createRef();
    this.recaptchaRef = React.createRef();

    this.state = {
      school: '',
      source: 'schola',
      domain: 'school.schola.com',
      fillForm: false,
      googleApiLoaded: true,
      manuallyEnterSchoolAddress: false,
      autoCompleteSearchValue: '',
      autoCompleteStateFilter: '',
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        jobTitle: '',
        school: {
          address: '',
          name: '',
          city: '',
          state: '',
          zip: '',
          type: '',
          phone: '',
        },
        helpReach: [],
        trigger: props.trigger || 'N/A',
      },
      selectedGrades: [],
      validationErrors: {},
      modalConfirmVisible: false,
      modalAboutSchola: false,
      claimStatus: {
        title: '',
        message: '',
      },
      recaptchaValue: null,
      isRecaptchaValid: false,
    };
  }

  componentDidMount() {
    if (this.props.params.source) {
      this.setState({ source: this.props.params.source });
    } else if (window.parent !== window) {
      this.setState({ source: 'embedded' });
    }

    if (this.props.params.domain) {
      this.setState({ domain: this.props.params.domain });
    }

    if (this.props.params.schoolId) {
      client.get(`schools/${this.props.params.schoolId}`).then((response) => {
        if (response.status === 200) {
          response.json().then((school) => {
            const form = { ...this.state.form };

            form.school = {
              address: school.address,
              name: school.name,
              city: school.city,
              state: school.state,
              zip: school.zip,
              id: school.id,
              phone: school.phone,
              type: school.type,
            };

            this.setState({
              school,
              form,
              autoCompleteStateFilter: school.state.trim(),
              autoCompleteSearchValue: school.name,
            });
            this.setGrades();
          });
        }
      });
    }
  }

  intGrade = (grade) => {
    let ordinal = 0;
    switch (grade) {
      case 'Pre-K':
        ordinal = -3;
        break;
      case 'TK':
        ordinal = -2;
        break;
      case 'HS':
        ordinal = -1;
        break;
      case 'K':
        ordinal = 0;
        break;
      default:
        ordinal = parseInt(grade);
        break;
    }
    return ordinal;
  };

  setGrades = () => {
    const { school } = this.state;
    const selectedGrades = [];
    if (school) {
      const { grades } = school;
      if (grades) {
        let _grades = grades.split(',');
        _grades.forEach((grade) => {
          if (grade !== '') {
            selectedGrades.push({ value: grade, label: grade === 'HS' ? 'Head Start' : grade });
          }
        });
      }
      selectedGrades.sort((a, b) =>
        this.intGrade(a.value) > this.intGrade(b.value) ? 1 : this.intGrade(b.value) > this.intGrade(a.value) ? -1 : 0
      );
    }

    this.setState({ selectedGrades });
  };

  renderSchoolInputs = () => {
    const schoolNameInput = this.renderSchoolNameInput();

    let addressInput = null;
    if (this.state.manuallyEnterSchoolAddress) {
      addressInput = this.renderSchoolAddressAutoComplete();
    }

    return (
      <div className="form-school-info">
        {schoolNameInput}
        {addressInput}
      </div>
    );
  };

  getValidationMessages = (field) => {
    return this.state.validationErrors[field] || [];
  };

  updateSchoolFields = (fields) => {
    if (fields.name) {
      this.clearValidationForField('school.name');
    }

    const form = { ...this.state.form };
    form.school = Object.assign(form.school, fields);
    this.setState({ form });
  };

  clearValidationForField = (field) => {
    const validationErrors = { ...this.state.validationErrors };
    delete validationErrors[field];
    this.setState({ validationErrors });
  };

  renderSchoolNameInput = () => {
    if (this.state.manuallyEnterSchoolAddress) {
      return (
        <div className="form-group">
          <label>School Name</label>
          <Validation messages={this.getValidationMessages('school.name')}>
            <Text value={this.state.form.school.name} onChange={(value) => this.updateSchoolFields({ name: value })} />
          </Validation>
        </div>
      );
    }

    return this.renderSchoolNameAutoComplete();
  };

  renderSchoolNameAutoComplete() {
    const { state, props } = this;
    let noResultsFoundDialogue = null;
    const schools = this.props.autoCompleteSchools ? this.props.autoCompleteSchools.toJS().results : [];

    const handleAutoCompleteSelect = (name, school) => {
      const { id, address, city, state, zip, phone, type } = school;
      this.updateSchoolFields({ id, address, city, state, zip, name, phone, type });
      this.setState({ autoCompleteSearchValue: name, school });
      this.props.dispatch(resetAutocompleteSchools());
    };

    const handleAutoCompleteValueChange = (event, value) => {
      this.clearValidationForField('school.name');

      this.setState({ autoCompleteSearchValue: value }, () => {
        refreshSearchResults(value);
      });
    };

    const refreshSearchResults = (name) => {
      const { autoCompleteStateFilter } = this.state;
      const query = { name };

      if (autoCompleteStateFilter.length) {
        query.state = autoCompleteStateFilter;
      }

      this.props.dispatch(getAutocompleteSchools(query));
    };

    const toggleManualAddressForm = () => {
      const form = { ...this.state.form };
      form.school.name = '';
      this.setState({
        manuallyEnterSchoolAddress: !this.state.manuallyEnterSchoolAddress,
        autoCompleteSearchValue: '',
        autoCompleteStateFilter: '',
        form,
      });
      if (this.props.positionAbsolute) this.props.positionAbsolute(this.setState({ classAbsolute: false }));
    };

    const autoComplete = (
      <div className="claim-school--autocomplete__wrapper mb-2">
        <label>{tString('landing:landingForm.schoolName')}</label>
        <div className="form-group" style={{ marginTop: 5 }}>
          <Validation messages={this.getValidationMessages('school.name')}>
            <Autocomplete
              inputProps={{
                id: 'claim-school--autocomplete',
              }}
              value={state.autoCompleteSearchValue}
              items={schools}
              open={schools.length > 0}
              getItemValue={(item) => item.name}
              onSelect={handleAutoCompleteSelect}
              onChange={handleAutoCompleteValueChange}
              renderInput={(props) => (
                <input {...props} className="form-control" style={{ fontSize: 12, borderColor: '#DDDFE7' }} />
              )}
              renderMenu={(items) => <div children={items} className="school-dropdown__menu" />}
              renderItem={(item, isHighlighted) => (
                <div
                  key={item.id}
                  style={isHighlighted ? { backgroundColor: '#99CC33' } : {}}
                  className="school-dropdown__results">
                  {item.name}, {item.state}, {item.city}, {item.zip}
                </div>
              )}
              wrapperStyle={{ display: 'block' }}
            />
          </Validation>
        </div>
        <button className={`${styles.textBlue} font-400 font-12 spacing-mb-32`} onClick={toggleManualAddressForm}>
          {tString('landing:landingForm.cantFind')}
        </button>
      </div>
    );
    const handleStateFilterChange = (state) => {
      this.setState({
        autoCompleteSearchValue: '',
        autoCompleteStateFilter: state,
      });
      this.props.dispatch(resetAutocompleteSchools());
    };

    const stateInput = (
      <div className="form-group">
        <p className="panel-label">{tString('landing:landingForm.state')}</p>
        <Dropdown
          options={stateOptions}
          value={state.autoCompleteStateFilter}
          onChange={handleStateFilterChange}
          className="select-state"
        />
      </div>
    );

    if (state.autoCompleteSearchValue && props.autoCompleteLoaded && !schools.length) {
      noResultsFoundDialogue = <span>{tString('landing:landingForm.noResultsFound')}</span>;
    }

    return (
      <div>
        {stateInput}

        {autoComplete}

        {noResultsFoundDialogue}
      </div>
    );
  }

  renderSchoolAddressAutoComplete = () => {
    if (!this.state.googleApiLoaded) {
      return null;
    }

    const handleGeoSuggestSelect = (place) => {
      const { address, city, state, zip } = place;
      this.updateSchoolFields({ address, city, state, zip });
    };

    const { form, selectedGrades } = this.state;

    const typeOptions = [
      { value: 'public district', label: 'Public District' },
      { value: 'Public Charter', label: 'Public Charter' },
      { value: 'Private', label: 'Private' },
      { value: 'Vocational', label: 'Vocational' },
      { value: 'Public Magnet', label: 'Public Magnet' },
      { value: 'Special', label: 'Special' },
      { value: 'Virtual / Online', label: 'Virtual / Online' },
    ];
    const schoolTypeChangeHandler = (optSelected) => {
      let { form } = this.state;
      form.school.type = optSelected;
      this.setState({ form });
    };

    const schoolGradeChangeHandler = (selectedGrades) => this.setState({ selectedGrades });

    const gradeOptions = [];
    defaultGrades.map((grade) => gradeOptions.push({ value: grade, label: grade }));

    return (
      <div className="form-group" id="claim">
        <label>{tString('landing:landingForm.schoolAddress')}</label>
        <Validation messages={this.getValidationMessages('school.address')}>
          <GooglePlacesField
            initialValue=""
            onChange={() => {
              this.clearValidationForField('school.address');
            }}
            onSelect={handleGeoSuggestSelect}
            skipSuggest={(suggest) => {
              return suggest.types.indexOf('geocode') === -1;
            }}
          />
        </Validation>

        <Validation messages={this.getValidationMessages('school.type')}>
          <NewDropdown
            label="Select Type"
            options={typeOptions}
            onChange={schoolTypeChangeHandler}
            value={form.school.type}
          />
        </Validation>

        <label className="mt-3">{tString('landing:landingForm.gradeOptions')}</label>
        <Select
          className="schola-select"
          classNamePrefix="schola"
          placeholder="Select all that apply"
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary25: '#99CC33',
              primary: '#6c6d70',
            },
          })}
          isMulti
          options={gradeOptions}
          onChange={schoolGradeChangeHandler}
          value={selectedGrades}
        />
        <label className="mt-3">{tString('landing:landingForm.schoolPhoneNumber')}:</label>
        <Validation messages={this.getValidationMessages('school.phone')}>
          <input
            type="text"
            value={form.school.phone}
            onChange={(e) => {
              let { form } = this.state;
              form.school.phone = e.target.value;
              this.setState({ form });
            }}
          />
        </Validation>
      </div>
    );
  };

  pasteCode = async (e, idx) => {
    e.preventDefault();
    e.clipboardData.items[0].getAsString((text) => {
      const _text = text.substring(0, 6);
      for (let index = 0; index < _text.length; index++) {
        const element = _text[index];
        const elementIdx = idx + index;
        this.setState({ [`digit${elementIdx}`]: element });
        // show on ui, the section is not a render function, so is neccesary put the value using the dom
        switch (elementIdx) {
          case 1:
            this.digit1.current.value = element;
            break;
          case 2:
            this.digit2.current.value = element;
            break;
          case 3:
            this.digit3.current.value = element;
            break;
          case 4:
            this.digit4.current.value = element;
            break;
          case 5:
            this.digit5.current.value = element;
            break;
          case 6:
            this.digit6.current.value = element;
            break;
        }
      }
      if (idx + _text.length <= 6) {
        document.querySelector(`input[name=digit${idx + _text.length}]`).focus();
      } else {
        document.querySelector(`input[name=digit6]`).focus();
      }
    });
  };

  deleteDigit = async (e, idx) => {
    if (e.keyCode === 8 && e.target.value === '') {
      e.preventDefault();
      document.querySelector(`input[name=digit${idx - 1}]`).focus();
    }
  };

  validForm = async () => {
    const validationErrors = {};
    let valid = true;
    if (this.state.form.school.name.trim() === '') {
      validationErrors['school.name'] = [tString('landing:landingForm.requiredField')];
      valid = false;
    }
    if (this.state.form.firstName.trim() === '') {
      validationErrors.firstName = [tString('landing:landingForm.requiredField')];
      valid = false;
    }
    if (this.state.form.lastName.trim() === '') {
      validationErrors.lastName = [tString('landing:landingForm.requiredField')];
      valid = false;
    }
    if (this.state.form.email.trim() === '') {
      validationErrors.email = [tString('landing:landingForm.requiredField')];
      valid = false;
    }
    if (this.state.form.phone.trim() === '') {
      validationErrors.phone = [tString('landing:landingForm.requiredField')];
      valid = false;
    }
    if (this.state.form.jobTitle.trim() === '') {
      validationErrors.jobTitle = [tString('landing:landingForm.requiredField')];
      valid = false;
    }
    if (this.state.manuallyEnterSchoolAddress) {
      if (this.state.form.school.address.length === 0) {
        validationErrors['school.address'] = [tString('landing:landingForm.requiredField')];
        valid = false;
      }
    }
    this.setState({ validationErrors });
    return valid;
  };

  submit = async (e) => {
    e.preventDefault();
    if ((await this.validForm()) === false) return;

    const recaptchaValue = this.recaptchaRef.current.getValue();
    const response = await _verifyRecaptcha({ recaptchaValue });
    this.recaptchaRef.current.reset();
    this.setState({ recaptchaValue: null });
    if (response.code === 400) {
      return;
    }

    let grades = '';
    if (this.state.selectedGrades) {
      this.state.selectedGrades.forEach((op) => {
        grades += `${op.label},`;
      });
    }

    let claimedSchool = { ...this.state.form };

    let helpToReach = `${tString('landing:landingForm.whatGoalscanScholaHelp')}\n`;
    if (this.state.form.helpReach !== undefined) {
      this.state.form.helpReach.map(
        (hrId) => (helpToReach += ` ${this.state.form.helpReach.find((hr) => hr.id == hrId)?.label}\n`)
      );
    }

    helpToReach += `OtherMessage:${this.state.form.otherHelpReach}\n`;

    delete claimedSchool.helpReach;
    delete claimedSchool.otherHelpReach;
    claimedSchool.school.grades = grades || '';

    claimedSchool = { ...claimedSchool };
    const result = await this.props.dispatch(claimSchool(claimedSchool));
    if (result.json) {
      let claimStatus = {
        title: tString('landing:landingForm.whileWeVerify'),
        message: '',
      };
      if (result.json.validationErrors) {
        const errors = {};
        const validationMessageMap = config.validationMessageMap || {};

        result.json.validationErrors.forEach((validationError) => {
          if (!errors[validationError.key]) {
            errors[validationError.key] = [];
          }
          errors[validationError.key].push(validationMessageMap[validationError.type] || validationError.message);
        });
        this.setState({
          validationErrors: errors,
        });
      } else {
        if (result.json.emailValidation) {
          // was an automatic claim
          claimStatus.message = 'automatic';
        } else {
          // manual claim , todo: change the message
          claimStatus.message = 'manual';
        }
        this.setState({ modalAboutSchola: false, modalConfirmVisible: true, playVideo: '' });
        this.trackEvent('submit');
        // clear form
        this.setState({
          fillForm: false,
          manuallyEnterSchoolAddress: false,
          autoCompleteSearchValue: '',
          autoCompleteStateFilter: '',
          form: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            jobTitle: '',
            school: {
              address: '',
              name: '',
              city: '',
              state: '',
              zip: '',
              type: '',
              phone: '',
            },
            helpReach: [],
          },
          selectedGrades: [],
          validationErrors: {},
        });
      }
      this.setState({ claimStatus });
    }
  };

  renderModalConfirm = () => {
    const { form } = this.state;
    return (
      <Modal
        isVisible={this.state.modalConfirmVisible}
        onClose={() => {
          this.setState({ modalConfirmVisible: false });
          this.props.toggleClaim();
        }}
        className="modal-confirm">
        <div className="d-flex" style={{ gap: '1rem' }}>
          <div className="icon-sending">
            <img
              src="https://scholamatch-static.s3-us-west-2.amazonaws.com/v2/claim/icon-sending.svg"
              alt="schola sending"
            />
          </div>
          <div className="sending-content d-flex flex-column justify-content-center">
            {this.state.claimStatus.message === 'manual' && (
              <>
                <p className="font-28 font-600 spacing-mb-32">{tString('landing:landingForm.messageSent')}</p>
                <p className="font-16 spacing-mb-24">{tString('landing:landingForm.weReceivedYourInformation')}</p>
              </>
            )}
            {this.state.claimStatus.message === 'automatic' && (
              <>
                <p className="font-28 font-600 spacing-mb-32">{tString('landing:landingForm.checkYourInbox')}</p>
                <p className="font-16 spacing-mb-24">
                  {tString('landing:landingForm.verifiedEmail')}
                  <br />
                  {tString('landing:landingForm.checkInboxAlert').replace('{{email}}', form.email)}
                </p>
              </>
            )}
            <Button
              type="button"
              color="primary"
              theme="outlined"
              onClick={() => {
                this.setState({ modalConfirmVisible: false });
                this.props.toggleClaim();
              }}>
              {' '}
              {tString('landing:landingForm.close')}
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  trackEvent = (action) => {
    this.trackEventOnFBPixel(action);
    // this.trackEventOnGoogle(action);
  };

  // trackEventOnGoogle = (action) => {
  //   switch (action) {
  //     case 'fill':
  //       window.gtag('event', 'conversion', { send_to: config.google.gtag.tags.fill_claim_your_school_school_portal });
  //       break;
  //     case 'submit':
  //       window.gtag('event', 'conversion', { send_to: config.google.gtag.tags.submit_claim_your_school_school_portal });
  //       break;
  //   }
  // };

  trackEventOnFBPixel = (action) => {
    // track custom event
    let grades = '';
    this.state.selectedGrades.forEach((op) => {
      grades += `${op.label},`;
    });
    ReactPixel.trackCustom(`${action}-claim-your-school-school-portal`, {
      source: this.state.source,
      email: this.state.form.email,
      name: `${this.state.form.firstName}${this.state.form.lastName}`,
      title: this.state.form.jobTitle,
      phone: this.state.form.phone,
      school: [
        {
          school_id: this.state.school.id,
          name: this.state.school.name,
          city: this.state.school.city,
          state: this.state.school.state,
          zip: this.state.school.zip,
          address: this.state.school.state,
          grades,
          type: this.state.school.type,
        },
      ],
    });
    if (action === 'submit') {
      ReactPixel.track(`CompleteRegistration`, {
        value: 0,
        currency: 'USD',
        custom_data: {
          domain: this.state.domain,
          source: this.state.source,
          user_agent: navigator.userAgent,
          registration_method: 'website',
          email: this.state.form.email,
          name: `${this.state.form.firstName}${this.state.form.lastName}`,
          title: this.state.form.jobTitle,
          phone: this.state.form.phone,
        },
      });
    }
  };

  updateField = (field, value) => {
    this.clearValidationForField(field);
    const form = { ...this.state.form };
    form[field] = value;
    let { fillForm } = this.state;
    if (!fillForm && (this.state.form.email !== '' || this.state.form.phone !== '')) {
      fillForm = true;
      this.trackEvent('fill');
    }
    this.setState({ form, fillForm });
  };

  render() {
    const { form } = this.state;

    const onChangeHelpReach = (elem) => {
      const { form } = this.state;
      if (!form?.helpReach) form.helpReach = [];

      const idx = form?.helpReach.findIndex((hr) => hr == elem.id);
      if (idx > -1) form.helpReach.splice(idx, 1);
      else form.helpReach.push(elem.id);
      this.setState({ form });
    };

    const onChangeHelpReachOther = (elem) => {
      setState({ form: { ...form, otherHelpReach: e.target.value } });
    };

    return (
      <div className={`${styles.paper} paper claim-form-column`}>
        <h3 className="heading-3 spacing-mb-16">{tString('landing:landingForm.title')}</h3>
        <form onSubmit={this.submit}>
          <h4 className="spacing-mb-16">{tString('landing:landingForm.description')}</h4>
          {this.renderSchoolInputs()}
          <h4 className="spacing-mb-4">{tString('landing:landingForm.contactInformation')}</h4>
          <div className="row">
            <div className="col-6">
              <label className="mt-3">{tString('landing:landingForm.firstName')}</label>
              <Validation messages={this.getValidationMessages('firstName')}>
                <Text value={form.firstName} onChange={(value) => this.updateField('firstName', value)} />
              </Validation>
            </div>
            <div className="col-6">
              <label className="mt-3">{tString('landing:landingForm.lastName')}</label>
              <Validation messages={this.getValidationMessages('lastName')}>
                <Text value={form.lastName} onChange={(value) => this.updateField('lastName', value)} />
              </Validation>
            </div>
          </div>
          <label className="mt-3">{tString('landing:landingForm.email')}</label>
          <Validation messages={this.getValidationMessages('email')}>
            <Text value={form.email} onChange={(value) => this.updateField('email', value)} />
          </Validation>
          <div className="row" style={{ marginTop: 0 }}>
            <div className="col-6">
              <label className="mt-3">{tString('landing:landingForm.phone')}</label>
              <Validation messages={this.getValidationMessages('phone')}>
                <Text value={form.phone} onChange={(value) => this.updateField('phone', value)} />
              </Validation>
            </div>
            <div className="col-6">
              <label className="mt-3">{tString('landing:landingForm.extension')}</label>
              <Text value={form.ext} onChange={(value) => this.updateField('ext', value)} />
            </div>
          </div>
          <label className="mt-3">{tString('landing:landingForm.jobTitle')}</label>
          <Validation messages={this.getValidationMessages('jobTitle')}>
            <Text value={form.jobTitle} onChange={(value) => this.updateField('jobTitle', value)} />
          </Validation>
          <div className="row checkboxes-goals-can-schola-help">
            <div className="col-12">
              <h4 className="spacing-mb-8">{tString('landing:landingForm.goals')}</h4>
            </div>
            <ClaimFormCheckboxes
              form={this.state.form}
              onChangeHelpReach={onChangeHelpReach}
              onChangeHelpReachOther={onChangeHelpReachOther}
            />
          </div>
          <div className={styles.recaptchaContainer}>
            <ReCAPTCHA
              sitekey={config.google.recaptcha.siteKey || ''}
              ref={this.recaptchaRef}
              onChange={(value) => {
                this.setState({ recaptchaValue: value });
              }}
            />
          </div>
          <div className={styles.claimButtonContainer}>
            <Button
              type="submit"
              color="greenlegacy"
              fullWidthMobile
              fontWeight="bold"
              disabled={this.state.recaptchaValue === null}>
              {tString('landing:landingForm.CTAClaim')}
            </Button>
          </div>
        </form>
        {this.renderModalConfirm()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  claimSchool: state.school.claimSchool,
  autoCompleteSchools: state.school.getAutocompleteSchools.get('data'),
  autoCompleteLoaded: state.school.getAutocompleteSchools.get('loaded'),
});

export default connect(mapStateToProps)(withTranslation()(withRouter(ClaimForm)));
